import type { ISocialApplyOffer } from "@api";
import type { ICandidate } from "@bbj-types/candidate";
import type { IChallenge } from "@bbj-types/challenge";
import type { ISocialOffer } from "@bbj-types/offer";
import type { ISocialApplyTransition } from "@bbj-types/socialApply";
import type { SocialApplyStatus } from "@bbj-types/socialApply/enum";
import { List, ListItem, Stack, Typography } from "@mui/material";
import dompurify from "isomorphic-dompurify";
import type { Dispatch, SetStateAction } from "react";
import { DrawerOfferBodyDocument } from "../../../offers/Document";
import { DrawerSocialOfferBodyInfo } from "./info";
import { DrawerSocialOfferBodyRegister } from "./register";
import { DrawerBody, classes } from "./styles";
import { DrawerSocialOfferBodyType } from "./type";

interface IDrawerSocialOfferBodyProps {
  offer: ISocialOffer & {
    applyCreatedAt?: Date;
    status?: SocialApplyStatus;
    transitions?: ISocialApplyTransition[];
    socialApplyId?: string;
  };
  challenges: IChallenge[];
  expired: boolean;
  candidate?: ICandidate;
  setSocialApplyOfferFupModal?: Dispatch<SetStateAction<ISocialApplyOffer | null>>;
  readOnly?: boolean;
}

export const DrawerSocialOfferBody = ({
  offer,
  challenges,
  expired,
  candidate,
  setSocialApplyOfferFupModal,
}: IDrawerSocialOfferBodyProps) => {
  return (
    <DrawerBody className={classes.root}>
      <Stack className={classes.descriptions}>
        {offer.description && (
          <Stack>
            <Typography variant="subtitle1SemiBold">Présentation du service</Typography>
            {/* biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation> */}
            <div dangerouslySetInnerHTML={{ __html: dompurify.sanitize(offer.description) }} />
          </Stack>
        )}
        {offer.beneficiaries && (
          <Stack>
            <Typography variant="subtitle1SemiBold">Qui peut bénéficier de ce service ?</Typography>
            {/* biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation> */}
            <div dangerouslySetInnerHTML={{ __html: dompurify.sanitize(offer.beneficiaries) }} />
          </Stack>
        )}
        {offer.perimeter && offer.perimeter.length > 0 && (
          <Stack>
            <Typography variant="subtitle1SemiBold">Offre ouverte aux habitants de :</Typography>
            <List sx={{ py: 0 }}>
              {offer.perimeter.map((perimeter) => (
                <ListItem key={perimeter._id} sx={{ py: 0 }}>
                  • {perimeter.placeLabel}
                </ListItem>
              ))}
            </List>
          </Stack>
        )}
      </Stack>
      <Stack className={classes.cards}>
        <DrawerSocialOfferBodyType offer={offer} challenges={challenges} />
        <DrawerSocialOfferBodyRegister
          offer={offer}
          expired={expired}
          candidate={candidate}
          setSocialApplyOfferFupModal={setSocialApplyOfferFupModal}
        />
        <DrawerSocialOfferBodyInfo offer={offer} />
        {offer.documents && offer.documents.length > 0 && <DrawerOfferBodyDocument documentIds={offer.documents} />}
      </Stack>
    </DrawerBody>
  );
};
